export type Currency = keyof typeof CURRENCIES;

export const CURRENCIES = {
  AUD: { symbol: '$' },
  BRL: { symbol: 'R$' },
  CAD: { symbol: '$' },
  CHF: { symbol: 'CHF' },
  CZK: { symbol: 'Kč' },
  DKK: { symbol: 'kr' },
  EUR: { symbol: '€' },
  GBP: { symbol: '£' },
  HKD: { symbol: '$' },
  HUF: { symbol: 'Ft' },
  ILS: { symbol: '₪' },
  JPY: { symbol: '¥' },
  MXN: { symbol: '$' },
  MYR: { symbol: 'RM' },
  NOK: { symbol: 'kr' },
  NZD: { symbol: '$' },
  PHP: { symbol: '₱' },
  PLN: { symbol: 'zł' },
  RUB: { symbol: '₽' },
  SEK: { symbol: 'kr' },
  SGD: { symbol: '$' },
  THB: { symbol: '฿' },
  TWD: { symbol: 'NT$' },
  USD: { symbol: '$' },
  COP: { symbol: '$' },

  BIF: { symbol: 'FBu' },
  CVE: { symbol: '$' },
  KMF: { symbol: 'CF' },
  CDF: { symbol: 'FC' },
  DJF: { symbol: 'Fdj' },
  ERN: { symbol: 'ናቕፋ' },
  GNF: { symbol: 'FG' },
  LSL: { symbol: 'L' },
  LYD: { symbol: 'ل.د' },
  MWK: { symbol: 'MK' },
  MRO: { symbol: 'UM' },
  SLL: { symbol: 'LE' },
  SZL: { symbol: 'L' },
  TJS: { symbol: 'TJS' },
  TOP: { symbol: 'T$' },
  XPF: { symbol: 'F' },
  XOF: { symbol: 'CFA' },
  XAF: { symbol: 'FCFA' },
  WST: { symbol: 'WS$' },
  VUV: { symbol: 'VT' },
  UGX: { symbol: 'USh' },
  TZS: { symbol: 'TSh' },
  STD: { symbol: 'Db' },
  RWF: { symbol: 'R₣' },
  PGK: { symbol: 'K' },
  MVR: { symbol: 'Rf' },
  MOP: { symbol: 'MOP$' },
  MMK: { symbol: 'K' },
  MDL: { symbol: 'L' },
  HTG: { symbol: 'G' },
  GMD: { symbol: 'D' },
  GEL: { symbol: 'GEL' },
  ETB: { symbol: 'Br' },
  BTN: { symbol: 'Nu.' },
  BDT: { symbol: '৳' },
  AOA: { symbol: 'Kz' },
  AED: { symbol: 'AED' },
  MGA: { symbol: 'Ar' },
  GHS: { symbol: 'GH₵' },
  TMT: { symbol: 'T' },
  DZD: { symbol: 'دج' },
  MAD: { symbol: 'د.م.' },
  KWD: { symbol: 'د.ك' },
  TND: { symbol: 'د.ت' },
  AZN: { symbol: 'ман' },
  BGL: { symbol: 'лв', isDisabled: true },
  BGN: { symbol: 'лв' },
  UZS: { symbol: 'сум' },
  KZT: { symbol: '₸' },
  KGS: { symbol: 'сом' },
  RSD: { symbol: 'РСД' },
  MKD: { symbol: 'ден' },
  TTD: { symbol: 'TT$' },
  PEN: { symbol: 'S/.' },
  SOS: { symbol: 'S' },
  IDR: { symbol: 'Rp' },
  DOP: { symbol: 'RD$' },
  ZAR: { symbol: 'R' },
  GTQ: { symbol: 'Q' },
  BYN: { symbol: 'BYR' },
  BWP: { symbol: 'P' },
  MZN: { symbol: 'MT' },
  ALL: { symbol: 'Lek' },
  RON: { symbol: 'lei' },
  HNL: { symbol: 'L' },
  KES: { symbol: 'Ksh' },
  ISK: { symbol: 'kr' },
  HRK: { symbol: 'kn' },
  BAM: { symbol: 'KM' },
  JOD: { symbol: 'JD' },
  JMD: { symbol: 'J$' },
  PYG: { symbol: 'Gs' },
  AWG: { symbol: 'ƒ' },
  ANG: { symbol: 'ƒ' },
  NIO: { symbol: 'C$' },
  BZD: { symbol: 'BZ$' },
  VEF: { symbol: 'Bs' },
  PAB: { symbol: 'B/.' },
  YER: { symbol: '﷼' },
  SAR: { symbol: '﷼' },
  QAR: { symbol: '﷼' },
  OMR: { symbol: '﷼' },
  SCR: { symbol: '₨' },
  PKR: { symbol: '₨' },
  NPR: { symbol: '₨' },
  MUR: { symbol: '₨' },
  LKR: { symbol: '₨' },
  UAH: { symbol: '₴' },
  MNT: { symbol: '₮' },
  LAK: { symbol: '₭' },
  VND: { symbol: '₫' },
  KRW: { symbol: '₩' },
  NGN: { symbol: '₦' },
  CRC: { symbol: '₡' },
  KHR: { symbol: '៛' },
  AFN: { symbol: '؋' },
  CNY: { symbol: '¥' },
  FKP: { symbol: '£' },
  SHP: { symbol: '£' },
  GIP: { symbol: '£' },
  LBP: { symbol: '.ل.ل' },
  EGP: { symbol: '£' },
  UYU: { symbol: '$U' },
  BOB: { symbol: '$b' },
  BMD: { symbol: 'BD$' },
  SBD: { symbol: '$' },
  XCD: { symbol: '$' },
  LRD: { symbol: '$' },
  KYD: { symbol: '$' },
  GYD: { symbol: '$' },
  FJD: { symbol: '$' },
  CLP: { symbol: '$' },
  BSD: { symbol: '$' },
  BND: { symbol: '$' },
  BBD: { symbol: '$' },
  ARS: { symbol: '$' },
  NAD: { symbol: '$' },
  SRD: { symbol: '$' },
  BHD: { symbol: '.د.ب' },
  AMD: { symbol: 'AMD' },
  TRY: { symbol: '₺' },
  INR: { symbol: '₹' },
  IQD: { symbol: 'ع.د' },
  ZMW: { symbol: 'ZK' },
} as const;
